// 流媒体服务器配置：推流/拉流地址统一从这里取

import siteConfig from './site-config';
import { getStreamingHost, getWebRtcUrl, getSrtPublishUrl } from '../utils/srsWebRtcPlayer';

const streamingConfig = {
  streaming: {
    production: {
      rtmp: process.env.REACT_APP_RTMP_BASE || `rtmp://${getStreamingHost()}:1935/live`,
      flv: `${siteConfig.getStreamingUrl()}/proxy-flv`,
      hls: `${siteConfig.getStreamingUrl()}/proxy-m3u8`,
      http: siteConfig.getStreamingUrl(),
      // 直连 SRS HTTP-FLV（兜底调试用）
      flvDirect: process.env.REACT_APP_FLV_DIRECT_BASE || `http://${getStreamingHost()}:8080/live`
    },
    development: {
      rtmp: process.env.REACT_APP_RTMP_BASE || `rtmp://${getStreamingHost()}:1935/live`,
      flv: `${siteConfig.getStreamingUrl()}/proxy-flv`,
      hls: `${siteConfig.getStreamingUrl()}/proxy-m3u8`,
      http: siteConfig.getStreamingUrl(),
      flvDirect: process.env.REACT_APP_FLV_DIRECT_BASE || `http://${getStreamingHost()}:8080/live`
    },
    fallback: {
      rtmp: process.env.REACT_APP_RTMP_FALLBACK || `rtmp://${getStreamingHost()}:1935/live`,
      flv: `${siteConfig.getStreamingUrl()}/proxy-flv`,
      hls: `${siteConfig.getStreamingUrl()}/proxy-m3u8`,
      http: siteConfig.getStreamingUrl(),
      flvDirect: process.env.REACT_APP_FLV_DIRECT_BASE || `http://${getStreamingHost()}:8080/live`
    }
  },

  getCurrentConfig() {
    const isProduction = process.env.NODE_ENV === 'production';
    return isProduction ? this.streaming.production : this.streaming.development;
  },

  getRtmpUrl(streamKey) {
    const config = this.getCurrentConfig();
    return `${config.rtmp}/${streamKey}`;
  },

  getSrtUrl(streamKey) {
    return getSrtPublishUrl(streamKey);
  },

  getWebRtcUrl(streamKey) {
    return getWebRtcUrl(streamKey);
  },

  getFlvUrl(streamKey) {
    const config = this.getCurrentConfig();
    return `${config.flv}/${streamKey}`;
  },

  getHlsUrl(streamKey) {
    const config = this.getCurrentConfig();
    return `${config.hls}/${streamKey}`;
  },

  getHttpBaseUrl() {
    const config = this.getCurrentConfig();
    return config.http;
  },

  getFallbackConfig() {
    return this.streaming.fallback;
  },

  async checkServerHealth() {
    try {
      const config = this.getCurrentConfig();
      const response = await fetch(`${config.http}/health`, {
        method: 'GET',
        timeout: 5000
      });
      return response.ok;
    } catch (error) {
      console.warn('流媒体服务器健康检查失败:', error);
      return false;
    }
  }
};

export default streamingConfig;
